import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const socialIcon: SxStyle = {
  '&:hover': {
    color: (p) => p.palette.primary[300],
  },
};
